'use client';

import { c as _c } from "react/compiler-runtime";
import { useTripLoyaltyPricing } from '../hooks/useTripLoyaltyPricing';
import { useTripPriceSummary } from '../hooks/useTripPriceSummary';
import { TripPriceDetails } from './TripPriceDetails';
type TripPriceDetailsContentProps = {
  paxCount: number;
  roomCount: number;
  pricePerPerson: number;
};
export const TripPriceDetailsContent = t0 => {
  const $ = _c(20);
  const {
    paxCount,
    roomCount,
    pricePerPerson
  } = t0;
  const {
    totalPrice,
    formatPrice
  } = useTripPriceSummary();
  const loyalty = useTripLoyaltyPricing();
  const t1 = loyalty.hasLoyaltyDiscount ? loyalty.originalTotalFormatted : undefined;
  const t2 = totalPrice ?? 0;
  const t3 = totalPrice ?? 0;
  let t4;
  if ($[0] !== formatPrice || $[1] !== t3) {
    t4 = formatPrice(t3);
    $[0] = formatPrice;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t2 || $[4] !== t4) {
    t5 = {
      value: t2,
      formatted: t4
    };
    $[3] = t2;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== formatPrice || $[7] !== pricePerPerson) {
    t6 = formatPrice(pricePerPerson);
    $[6] = formatPrice;
    $[7] = pricePerPerson;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== pricePerPerson || $[10] !== t6) {
    t7 = {
      value: pricePerPerson,
      formatted: t6
    };
    $[9] = pricePerPerson;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = {
      total: t5,
      perPerson: t7
    };
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== paxCount || $[16] !== roomCount || $[17] !== t1 || $[18] !== t8) {
    t9 = <TripPriceDetails loyaltyOriginalTotalFormatted={t1} paxCount={paxCount} roomCount={roomCount} offerDeposit={false} animate={true} price={t8} />;
    $[15] = paxCount;
    $[16] = roomCount;
    $[17] = t1;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};